import { EmployeePaymentsDataDto } from "./employee-payments-data-dto";

export class EmployeePaymentsDto {
  attendanceIds: number[];
  subContractorIds: number;
  projectIds: number;
  attendanceDetails: EmployeePaymentsDataDto[];
  paymentDate: Date;
  paidDate: Date;
}
